import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pill, Heading, Text } from '@dotcom/crown-ui';
import styles from '../../select-envelope.module.scss';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className={styles['envelope-card-header']}>
      <Heading as="h2" className={styles.title} styleVariant="subtitle">
        {t('envelopeSelection.title')} <Pill title="Free!" className={styles['pill-element']} />
      </Heading>
      <Text as="span" color="textPrimary">
        {t('envelopeSelection.description')}
      </Text>
    </header>
  );
};
